import MusicApp from './components/MusicApp';

let components = {
  MusicApp,
}

class OnLoad {
  run() {
    this.setWindowGlobals()
    this.runOnDOM()
    this.runOnLoad()
  }

  // <script> code on pages should run in window.addEventListener('load') in order to come after this
  runOnDOM() {
    document.addEventListener('DOMContentLoaded', () => {
    })
  }

  runOnLoad() {
    window.addEventListener('load', () => {
    })
  }

  setWindowGlobals() {
    window.app.components = { ...window.app.components, ...components }
  }
}

export default new OnLoad